<template>
  <div class="messageCenterinformationPage"
    @touchstart="touchEvent" 
    @touchmove="touchEvent" 
    @touchend="touchEvent" 
    @scroll="touchEvent">
      <XR-head titleText="资讯" :rightShow="false" ref="headObj"></XR-head>
      <div class="bannerlist">
          <XR-swiper ref="swiper" :showIndic="false" v-if="bannerList.length>0">
            <XR-slide :style="{height: bannerHeight+'px'}" v-for="(banner,index) in bannerList" :key="banner.Id">
              <a :href="banner.Url"><img :src="banner.ImgPath" /></a>
              <div class="title">
                <p>{{banner.Title}}</p><span>{{(index+1)}}/{{bannerList.length}}</span>
              </div>
            </XR-slide>
          </XR-swiper>   
      </div>
      <mu-list>
        <template v-for="infoItem in infoList">
          <template v-if="infoItem.TitleImages && infoItem.TitleImages.length ==0">          
            <mu-list-item  class="singular"  :key="infoItem.Id" :title="infoItem.Title" :describeText="infoItem.AddDate.replace('T',' ')" @click="goDetail(infoItem)">              
            </mu-list-item>
          </template>      
          <template v-if="infoItem.TitleImages && infoItem.TitleImages.length ==1">          
            <mu-list-item class="singular" :key="infoItem.Id" :title="infoItem.Title" :describeText="infoItem.AddDate.replace('T',' ')" @click="goDetail(infoItem)">
              <mu-avatar  :src="img" slot="right" v-for="img in infoItem.TitleImages" :key="img" />
            </mu-list-item>
          </template>       
          <template v-if="infoItem.TitleImages && infoItem.TitleImages.length ==3">     
            <mu-list-item  class="multi singular" :key="infoItem.Id" :title="infoItem.Title" @click="goDetail(infoItem)">
              <div class="moreImg" :style="{height: imgHeigth+'px'}">
                <img :src="img" v-for="img in infoItem.TitleImages" :key="img" />
              </div>
              <div class="date">{{infoItem.AddDate.replace('T',' ')}}</div>
            </mu-list-item>
          </template>     
        </template>  
      </mu-list>
    <XR-toast  ref="XRtoast"></XR-toast>
	<XR-PageTip ref="XRPageTip"></XR-PageTip>
  </div>
</template>
<style >
  
  body .messageCenterinformationPage{
    background: #eee;
  }
  .messageCenterinformationPage .XR-head{
    position: fixed;
    background: rgb(0,0,0,0);
    box-shadow: none;
    }
    .messageCenterinformationPage .XR-head .left .mu-icon-button .fa-angle-left {
      background: rgba(71,74,79,0.25);
      border-radius: 50%;
    }
    .messageCenterinformationPage .XR-head .mu-appbar-title span {
      background: rgba(71,74,79,0.25);
      padding: 3px 6px;
      color: #fff;
  }
  .messageCenterinformationPage .bannerlist{
      width: 100%;
  }
  .messageCenterinformationPage .bannerlist .wh_slide{
    position: relative;
  }
 .messageCenterinformationPage .bannerlist .wh_slide .title{
   width: 100%;
   background: #000;
   color: #fff;
   display: flex;
   padding: 0 0 0 4%;
   height: 30px;
   line-height: 30px;
   position: absolute;
   bottom: 0;
   opacity: 0.7;
 }
  .messageCenterinformationPage .bannerlist .wh_slide .title p{
    width: 90%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .messageCenterinformationPage .bannerlist .wh_slide img{
    width: 100%;
    height: 100%;
  }
   .messageCenterinformationPage .mu-list{
     background: #fff;
   }
   .messageCenterinformationPage .mu-list .singular,.messageCenterinformationPage .mu-list .multi{
     border-bottom: 1px solid #f5f5f5;
   }
   .messageCenterinformationPage .mu-list div:last-child{border: 0;font-size: 12px}
   .messageCenterinformationPage .mu-list .singular .mu-item{
    padding: 16px;
  }
  .messageCenterinformationPage .mu-list .singular .mu-item .mu-item-content{
    width: 75%;
  }
  .messageCenterinformationPage .mu-list .multi .mu-item .mu-item-content{
    width: 100%;
  }
  .messageCenterinformationPage .mu-list .singular .mu-item .mu-item-content .mu-item-text{
    font-size: 12px;
  }
  .messageCenterinformationPage .mu-list .singular .mu-item .mu-item-right{
    width: 20%;
    height: 40px;
    margin-top: 16px;
  }
  .messageCenterinformationPage .mu-list .singular .mu-item .mu-item-right .mu-avatar{
    width: 100%;
    height: 100%;
    border-radius: 0;
    
  }
  .messageCenterinformationPage .mu-list .singular .mu-item .mu-item-right .mu-avatar img{
    border-radius: 0;
    object-fit: cover;
  }
  .messageCenterinformationPage .mu-list .multi .mu-item{}
  .messageCenterinformationPage .mu-list .multi .mu-item .moreImg{
    width: 100%;
    text-align: center;
    margin-top: 10px;
  }
  .messageCenterinformationPage .mu-list .multi .mu-item .moreImg img{
    width: 30%;
    height: 100%;
    object-fit: cover;
  }
  .messageCenterinformationPage .mu-list .multi .mu-item .moreImg img:not(:first-child){
    margin-left: 3.5%;
  }
  .messageCenterinformationPage .mu-list .multi .mu-item .date{
    font-size: 12px;
    margin-top: 6px;
    color: #7e848c;
  }
  .messageCenterinformationPage .mu-list .mu-item .mu-item-title{
    font-size: 14px;
    font-weight: bold;
    line-height: 18px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
</style>
<script>
    export default {      
        data() {
            return {
              fullWidth : document.documentElement.clientWidth,
              bannerHeight: 0,
              bannerList:[],
              infoList: []
            }
        },
        mounted() {
            this.bannerHeight = this.fullWidth*140/320
            this.imgHeigth = this.fullWidth *50/320
            this.getBannerList()
            this.getInformationList()
        },
        methods: {
          touchEvent (){
              var scrollTop = this.$el.scrollTop
              var imgHeigth= document.querySelector('.bannerlist').offsetHeight+65 
              var opacityValue=this.$el.scrollTop/imgHeigth
              document.querySelector('.mu-appbar').style.background='rgba('+this.themeColor+','+opacityValue+')'
          }, 
           getBannerList(){
              var ths = this;   
              ths.$post(
                "/Shop/articleServer/GetInformationBannerList"
              ).then(function(res) {
                if(!res.IsSuccess){
                }else{          
                  ths.bannerList = res.Data;
                  ths.loaded = false
                  ths.$refs.XRtoast.hide()
                }
              });
           },
           getInformationList(){
              var ths = this;   
              ths.$post(
                "/Shop/articleServer/GetInformationPage"
              ).then(function(res) {
			    //res.IsSuccess = false
                if(!res.IsSuccess){
				  //res.Msg = "暂无数据"
				  ths.$refs.XRPageTip.ShowEmpty(res.Msg)
                }else{          
                  ths.infoList = res.Data.List;
                  ths.loaded = false
                  ths.$refs.XRtoast.hide()
                }
              });
           },
           goDetail(item){
             if(item.Type == 1){
               this.$router.push('/informationDetail?id='+item.Id)
             }else{
               this.$router.push('/informationImgDetail?id='+item.Id)
             }
           }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/information.vue